export default [
    // To test search by NDC function, uncomment object (lines 3 - 15) to test invalid NDC response and comment back in to test valid NDC response.
    {
        "hsn": null,
        "gcn": null,
        "drugName": "TYLENOL 8 HOUR",
        "covered": null,
        "drugLabelName": "TYLENOL 8 HOUR",
        "drugStrength": "650 MG",
        "drugType": null,
        "drugForm": "TABLET ER",
        "productId": null,
        "ndc": [
            "00450029711",
            "00450029751",
            "50580029705",
            "50580030902"
        ]
    }
]